import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {Game} from "../Game";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Sound} from "../sound/Sound";
import {GameFeatureMode} from "../enums/Enum";

export class PostIntro extends PIXI.Container implements StageLayer {
    private _tl: gsap.core.Timeline | null;
    private _prevSpaceBarSettings: boolean;
    private _stopped: boolean;

    constructor() {
        super();
        this.name = "POST_INTRO";
        this._prevSpaceBarSettings = false;
    }

    public play(): void {
        const tl: gsap.core.Timeline = gsap.timeline({delay: 0.1});
        this._stopped = false;

        this._prevSpaceBarSettings = Game.apiPlugin.settings.get(APISetting.USE_SPACE_TO_SPIN, false);
        Game.apiPlugin.settings.set(APISetting.USE_SPACE_TO_SPIN, false);

        Game.blackBG.interactive = true;
        Game.blackBG.buttonMode = true;
        Game.blackBG.once('pointerdown', () => {
            this.stopIntro();
        });
        Game.keypadPlugin.toggleVisibility(false);

        tl.add(() => {
            Game.blackBG.show(0.01);
            Game.soundPlayer.playSound(Sound.GAME_INTRO_ELEVATOR_SCENE);
            Game.backgroundElements.onPostIntroStart();
        });
        tl.add(Game.backgroundElements.playLiftAnim(Game.model.data.nextMode as GameFeatureMode));
        tl.add(() => {
            Game.blackBG.hide(0.5);
            Game.blackBG.interactive = false;
            Game.blackBG.buttonMode = false;
            Game.reelView.show();
        });

        tl.add(() => {
            NolimitApplication.removeLayer(this.name);
            Game.keypadPlugin.toggleVisibility(true);
            Game.backgroundElements.onPostIntroDone();
        });

        this._tl = tl;
    }

    public stopIntro(): void {
        if (this._stopped) {
            return;
        }

        if (this._tl && this._tl.isActive()) {
            Game.soundPlayer.playSound(Sound.CONTINUE_BUTTON);
            this._tl.totalProgress(1);
            Game.soundPlayer.stopSound(Sound.GAME_INTRO_ELEVATOR_SCENE);
            Game.keypadPlugin.toggleVisibility(true);
            this._tl = null;
        }

        Game.blackBG.interactive = false;
        Game.blackBG.buttonMode = false;

        Game.apiPlugin.settings.set(APISetting.USE_SPACE_TO_SPIN, this._prevSpaceBarSettings);

        this._stopped = true;
        this.visible = false;
    }
}